
  import {
    computed,
    defineComponent,
    useContext,
  } from '@nuxtjs/composition-api'
  import ClientMarks from '@/components/main/ui/ClientMarks.vue'
  import { hasClientMarks } from '@/utils/clientCategories'

  export default defineComponent({
    name: 'CallClientLabel',
    components: { ClientMarks },
    props: {
      client: {
        type: Object,
        default: null,
      },
      overflowPopup: {
        type: Boolean,
        default: true,
      },
      overflowPlain: {
        type: Boolean,
        default: false,
      },
      maxVisibleCategories: {
        type: Number,
        default: null,
      },
    },
    setup(props) {
      const { i18n } = useContext()

      const label = computed(() => {
        if (!props.client) {
          return i18n.t('components.call_client.new_client')
        }

        const name =
          props.client.name ||
          [props.client.f_name, props.client.m_name, props.client.l_name]
            .filter(Boolean)
            .join(' ')

        return name || i18n.t('pages.clients.page.client_not_specified')
      })

      return { label, hasClientMarks }
    },
  })
